import React, { useState,useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { set } from 'date-fns';

const DuplicateLayerDialog = ({ isOpen, onClose, onConfirm, defaultName }) => {
    const [layerName, setLayerName] = useState('');

    useEffect(() => {
        setLayerName(defaultName+"_");
    }, [defaultName]);

    const setNewName = (name) => {
        setLayerName(name);
    }

    const handleSubmit = e => {
        e.preventDefault();
        if (layerName.trim()) {
            onConfirm(layerName.trim());
            setLayerName('');
            onClose();
        }
    };

    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="sm:max-w-[425px]">
                <DialogHeader>
                    <DialogTitle>Duplicate Element</DialogTitle>
                </DialogHeader>
                <form onSubmit={handleSubmit}>
                    <div className="grid gap-4 py-4">
                        <div className="flex flex-col gap-2">
                            <label htmlFor="layerName" className="text-sm font-medium">
                                Duplicate Element Name
                            </label>
                            <Input
                                id="layerName"
                                value={layerName}
                                onChange={e => setNewName(e.target.value)}
                                autoFocus
                                className="w-full"
                            />
                        </div>
                    </div>
                    <DialogFooter>
                        <Button type="button" variant="outline" onClick={onClose}>
                            Cancel
                        </Button>
                        <Button type="submit" disabled={!layerName.trim()}>
                            Create
                        </Button>
                    </DialogFooter>
                </form>
            </DialogContent>
        </Dialog>
    );
};

export default DuplicateLayerDialog;
